import React from 'react';
import parse from 'html-react-parser';

export default function SectionHeading({
  title = '',
  titleUp = '',
  titleDown = '',
  subTitle = '',
  center,
}) {
  return (
    <div className={`flex flex-col ${center ? 'items-center text-center' : 'items-start'}`}>
      {titleUp && (
        <div className="inline-flex items-center gap-[0.6rem] text-[0.72rem] tracking-[0.2em] uppercase text-gold font-medium mb-4">
          <span className="w-[24px] h-px bg-gold block" />
          {parse(titleUp)}
        </div>
      )}

      {title && (
        <h2 className="font-serif text-3xl md:text-4xl lg:text-[2.8rem] font-light leading-[1.2] text-charcoal mb-0">
          {parse(title)}
        </h2>
      )}

      {titleDown && (
        <div className="inline-flex items-center gap-[0.6rem] text-[0.72rem] tracking-[0.2em] uppercase text-gold font-medium mt-3">
          <span className="w-[24px] h-px bg-gold block" />
          {parse(titleDown)}
        </div>
      )}

      {subTitle && (
        <p className="mt-5 text-base leading-[1.75] text-mid font-light max-w-[560px] mb-0">
          {parse(subTitle)}
        </p>
      )}
    </div>
  );
}
